var _path, _circle, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationMarkerPolonez = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA0029",
    d: "M20 0C11.664 0 5 6.664 5 15c0 2.883.86 5.11 2.352 7.367l11.07 16.797c.336.508.914.836 1.578.836s1.25-.336 1.578-.836l11.07-16.797C34.141 20.11 35 17.883 35 15c0-8.336-6.664-15-15-15m0 23.328c-4.602 0-8.336-3.734-8.336-8.344 0-4.609 3.734-8.343 8.336-8.343s8.336 3.734 8.336 8.343c0 4.61-3.734 8.344-8.336 8.344"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "svg_11a",
    width: 20,
    height: 4,
    x: 10,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.988 13.182H10v3.755h19.988z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EA0029",
    mask: "url(#svg_11a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.06 14.12c-.418 0-.774.137-1.066.41a1.315 1.315 0 0 0-.437 1q0 .5895.438.999c.291.272.647.409 1.066.409a1.5 1.5 0 0 0 1.063-.41c.294-.272.44-.605.44-.999s-.146-.726-.44-1a1.508 1.508 0 0 0-1.063-.408Zm.5 1.902a.68.68 0 0 1-.5.203.685.685 0 0 1-.5-.2.668.668 0 0 1-.203-.497c0-.197.067-.357.204-.493a.68.68 0 0 1 .5-.203c.197 0 .363.068.5.203a.67.67 0 0 1 .204.493.67.67 0 0 1-.205.493Zm2.118.11c-.049-.054-.073-.14-.073-.26v-2.69h-.8v2.811c0 .622.308.934.924.934.161 0 .288-.012.381-.037v-.696a.77.77 0 0 1-.193.02c-.111 0-.19-.027-.24-.081Zm2.053-2.012c-.419 0-.774.137-1.066.41a1.315 1.315 0 0 0-.438 1q0 .5895.438.999c.292.272.648.409 1.066.409a1.5 1.5 0 0 0 1.064-.41 1.31 1.31 0 0 0 .44-.999c0-.394-.146-.726-.44-1a1.508 1.508 0 0 0-1.064-.408Zm.5 1.902a.68.68 0 0 1-.5.203.685.685 0 0 1-.5-.2.667.667 0 0 1-.204-.497c0-.197.068-.357.205-.493a.68.68 0 0 1 .5-.203.68.68 0 0 1 .5.203.67.67 0 0 1 .204.493.67.67 0 0 1-.205.493Zm2.851-1.88c-.187 0-.35.036-.492.108a.643.643 0 0 0-.298.282V14.2h-.8v2.658h.8v-1.492a.51.51 0 0 1 .531-.528c.154 0 .28.045.366.135s.129.211.129.366v1.52h.8v-1.615c0-.345-.09-.614-.27-.81-.182-.195-.437-.292-.766-.292m6.906.058h-2.622v.69h1.252l-1.351 1.968h2.7v-.691h-1.33zm-16.815-.678a1.3 1.3 0 0 0-.868-.34h-1.514v.899h.827v-.396l1.48.742-1.48.74v-.396H10l.791.396v1.69h.827v-1.186h.687q.489 0 .876-.354c.257-.235.386-.533.386-.89 0-.377-.131-.678-.394-.905m12.657.609c-.425 0-.777.128-1.052.383q-.414.3825-.414 1.02c0 .424.136.759.408 1.01.273.252.63.377 1.075.377.444 0 .847-.161 1.165-.485 0 0 .079-.076.13-.148l-.597-.289a.94.94 0 0 1-.66.257c-.212 0-.383-.047-.514-.142a.472.472 0 0 1-.201-.347h2.07s.015-.088.015-.286a1.33 1.33 0 0 0-.41-.963c-.258-.258-.602-.387-1.014-.387Zm-.655 1.092c.01-.123.079-.228.204-.314a.777.777 0 0 1 .452-.129.67.67 0 0 1 .413.13c.115.085.172.19.172.313h-1.24Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationMarkerPolonez);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-marker-polonez.b541759384ce033be5e26f5e22439d48.svg";